import { Match, Switch, onMount } from 'solid-js';
import { Shell } from '@ui/Shell/Shell';
import { Board } from '@ui/Board/Board';
import { EvalBar } from '@ui/Eval/EvalBar';
import { BlindfoldQuiz } from '@ui/Blindfold/BlindfoldQuiz';
import { CheckmateQuiz } from '@ui/Checkmate/CheckmateQuiz';
import { HorseRideQuiz } from '@ui/HorseRide/HorseRideQuiz';
import { ModeHeats } from '@ui/Modes/ModeHeats';
import { ModePlaceholder } from '@ui/Modes/ModePlaceholder';
import { OpeningQuiz } from '@ui/Quiz/OpeningQuiz';
import { TacticAlertQuiz } from '@ui/Tactics/TacticAlertQuiz';
import { modeStore } from '@state/modeStore';
import { startEngineService } from '@engine/engineService';
import './app.css';

export default function App() {
  onMount(() => {
    window.setTimeout(() => startEngineService(), 50);
  });

  return (
    <Shell>
      <div class="play-layout">
        <div class="play-stage">
          <Switch>
            <Match when={modeStore.current === 'opening'}>
              <div class="play-area play-area--opening">
                <div class="play-board">
                  <EvalBar />
                  <Board />
                </div>
                <div class="play-quiz">
                  <OpeningQuiz />
                </div>
              </div>
            </Match>
            <Match when={modeStore.current === 'horse-ride'}>
              <div class="play-area">
                <div class="play-board">
                  <Board />
                </div>
                <div class="play-quiz">
                  <HorseRideQuiz />
                </div>
              </div>
            </Match>
            <Match when={modeStore.current === 'tactic-alert'}>
              <div class="play-area">
                <div class="play-board">
                  <EvalBar />
                  <Board />
                </div>
                <div class="play-quiz">
                  <TacticAlertQuiz />
                </div>
              </div>
            </Match>
            <Match when={modeStore.current === 'blindfold'}>
              <div class="play-area play-area--blindfold">
                <div class="play-quiz">
                  <BlindfoldQuiz />
                </div>
              </div>
            </Match>
            <Match when={modeStore.current === 'mating'}>
              <div class="play-area play-area--checkmate">
                <div class="play-board">
                  <EvalBar />
                  <Board />
                </div>
                <div class="play-quiz">
                  <CheckmateQuiz />
                </div>
              </div>
            </Match>
            <Match when={true}>
              <ModePlaceholder mode={modeStore.current} />
            </Match>
          </Switch>
        </div>
        <ModeHeats />
      </div>
    </Shell>
  );
}
